import type { FAQItem } from "@/lib/products";
import type { GeneralFAQItem } from "@/lib/data/faq/general";

/**
 * Convert FAQ data to Schema.org FAQPage schema format
 * Used for general FAQ page and product FAQ pages
 */
export function faqToFAQPageSchema(
  faqItems: FAQItem[] | GeneralFAQItem[],
  options?: {
    url?: string;
    name?: string;
    description?: string;
    dateModified?: string;
  }
) {
  if (!faqItems || faqItems.length === 0) {
    return null;
  }

  const url = options?.url || "https://plugmonkey.xyz/faq/";
  const name = options?.name || "PlugMonkey Chrome Extensions - Frequently Asked Questions";
  const description =
    options?.description ||
    "Get answers to common questions about PlugMonkey Chrome extensions. Learn about pricing, security, installation, and support for our products.";

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "@id": `${url}#faq`,
    name,
    alternateName: "PlugMonkey FAQ",
    url,
    description,
    dateModified: options?.dateModified || "2025-01-31T00:00:00Z",
    datePublished: "2023-01-01T00:00:00Z",
    inLanguage: "en-US",
    isPartOf: {
      "@type": "WebSite",
      "@id": "https://plugmonkey.xyz/#website",
      name: "PlugMonkey",
      url: "https://plugmonkey.xyz/",
    },
    mainEntity: faqItems.map((item, idx) => {
      const generalItem = item as GeneralFAQItem;
      const itemId = generalItem.value || `item-${idx}`;

      // Strip HTML tags from answer for schema (keep plain text)
      const plainTextAnswer = item.answer
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim();

      return {
        "@type": "Question",
        "@id": `${url}#${itemId}`,
        name: item.question,
        text: item.question,
        answerCount: 1,
        dateCreated: "2025-11-18T00:00:00Z",
        author: {
          "@type": "OnlineBusiness",
          name: "PlugMonkey",
          url: "https://plugmonkey.xyz/",
        },
        acceptedAnswer: {
          "@type": "Answer",
          text: plainTextAnswer,
          dateCreated: "2025-11-18T00:00:00Z",
          url: `${url}#${itemId}-answer`,
          author: {
            "@type": "OnlineBusiness",
            name: "PlugMonkey",
            url: "https://plugmonkey.xyz/",
          },
        },
      };
    }),
    publisher: {
      "@type": "OnlineBusiness",
      "@id": "https://plugmonkey.xyz/#onlinebusiness",
      name: "PlugMonkey",
    },
  };
}
